module.exports = __webpack_public_path__ + "img/hic-colorectal-cancer-male.3678fc72.png";